import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#7d59b5";
function NAV({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  fillRule="evenodd" d="M15.99 16.5h-3.597l-2.849-5.254L7.349 16.5H3.75l3.763-9h3.598l2.959 5.457L16.652 7.5h3.598z" clipRule="evenodd" /></Svg>;
}
NAV.DefaultColor = DefaultColor;
export default NAV;